// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_main_wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80")
    no-repeat center center/cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 1;
  color: #fff;
  font-family: "Arial", sans-serif;
  text-align: center;
}
.loginLoginBox {
  position: relative;
  width: 400px;
  padding: 40px;
  margin: 20px auto;
  background: rgba(0, 0, 0, 0.9);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}

.loginLoginHead {
  margin: 0 0 30px;
  padding: 0;
  color: #fff;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 1px;
}

.loginUserBox {
  position: relative;
  justify-content: center;
}

.loginUserBox input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  border: none;
  border-bottom: 1px solid #d65b3c;
  outline: none;
  background: transparent;
}

/* Override autofill styles */
.loginUserBox input:-webkit-autofill,
.loginUserBox input:-webkit-autofill:hover,
.loginUserBox input:-webkit-autofill:focus,
.loginUserBox input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px transparent inset !important;
  -webkit-text-fill-color: #fff !important;
  background: transparent !important;
  border-bottom: 1px solid #d65b3c !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s; /* Prevents background color change */
}

.loginUserBox label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  pointer-events: none;
  transition: 0.5s;
}

.loginUserBox input:focus ~ label,
.loginUserBox input:valid ~ label {
  top: -20px;
  left: 0;
  color: #fff;
  font-size: 12px;
}

.loginSubmitButton {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  font-weight: bold;
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: 0.5s;
  margin-top: 40px;
  letter-spacing: 3px;
  background: none;
  border: none;
  cursor: pointer;
}

.loginSubmitButton:hover {
  background: #d65b3c;
  color: #272727;
  border-radius: 5px;
}

.loginSubmitButton span {
  position: absolute;
  display: block;
}

.loginSubmitButton span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #d65b3c);
  animation: btn-anim1 1.5s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

.loginSubmitButton span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #d65b3c);
  animation: btn-anim2 1.5s linear infinite;
  animation-delay: 0.375s;
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}

.loginSubmitButton span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #d65b3c);
  animation: btn-anim3 1.5s linear infinite;
  animation-delay: 0.75s;
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}

.loginSubmitButton span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #d65b3c);
  animation: btn-anim4 1.5s linear infinite;
  animation-delay: 1.125s;
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}

.loginEyeIcon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
  .loginLoginBox {
    width: 350px;
    padding: 30px;
  }

  .loginLoginHead {
    font-size: 1.3rem;
    margin-bottom: 25px;
  }

  .loginUserBox input {
    font-size: 14px;
    padding: 8px 0;
    margin-bottom: 25px;
  }

  .loginUserBox label {
    font-size: 14px;
    padding: 8px 0;
  }

  .loginUserBox input:focus ~ label,
  .loginUserBox input:valid ~ label {
    top: -18px;
    font-size: 10px;
  }

  .loginSubmitButton {
    padding: 8px 16px;
    font-size: 14px;
    margin-top: 30px;
    letter-spacing: 2px;
  }
}

@media (max-width: 480px) {
  .loginLoginBox {
    width: 90%;
    padding: 20px;
    margin: 10px auto;
  }

  .loginLoginHead {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }

  .loginUserBox input {
    font-size: 13px;
    padding: 6px 0;
    margin-bottom: 20px;
  }

  .loginUserBox label {
    font-size: 13px;
    padding: 6px 0;
  }

  .loginUserBox input:focus ~ label,
  .loginUserBox input:valid ~ label {
    top: -16px;
    font-size: 9px;
  }

  .loginSubmitButton {
    padding: 6px 12px;
    font-size: 13px;
    margin-top: 20px;
    letter-spacing: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb;iCAC+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;;;;EAIE,2DAA2D;EAC3D,wCAAwC;EACxC,kCAAkC;EAClC,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD,EAAE,qCAAqC;AAC1F;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE;IACE,WAAW;EACb;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yDAAyD;EACzD,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,OAAO;EACP,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;EACA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".login_main_wrapper {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background: url(\"https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80\")\n    no-repeat center center/cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  z-index: 1;\n  color: #fff;\n  font-family: \"Arial\", sans-serif;\n  text-align: center;\n}\n.loginLoginBox {\n  position: relative;\n  width: 400px;\n  padding: 40px;\n  margin: 20px auto;\n  background: rgba(0, 0, 0, 0.9);\n  box-sizing: border-box;\n  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.6);\n  border-radius: 10px;\n}\n\n.loginLoginHead {\n  margin: 0 0 30px;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  letter-spacing: 1px;\n}\n\n.loginUserBox {\n  position: relative;\n  justify-content: center;\n}\n\n.loginUserBox input {\n  width: 100%;\n  padding: 10px 0;\n  font-size: 16px;\n  color: #fff;\n  margin-bottom: 30px;\n  border: none;\n  border-bottom: 1px solid #d65b3c;\n  outline: none;\n  background: transparent;\n}\n\n/* Override autofill styles */\n.loginUserBox input:-webkit-autofill,\n.loginUserBox input:-webkit-autofill:hover,\n.loginUserBox input:-webkit-autofill:focus,\n.loginUserBox input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px transparent inset !important;\n  -webkit-text-fill-color: #fff !important;\n  background: transparent !important;\n  border-bottom: 1px solid #d65b3c !important;\n  transition: background-color 5000s ease-in-out 0s; /* Prevents background color change */\n}\n\n.loginUserBox label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 10px 0;\n  font-size: 16px;\n  color: #fff;\n  pointer-events: none;\n  transition: 0.5s;\n}\n\n.loginUserBox input:focus ~ label,\n.loginUserBox input:valid ~ label {\n  top: -20px;\n  left: 0;\n  color: #fff;\n  font-size: 12px;\n}\n\n.loginSubmitButton {\n  position: relative;\n  display: inline-block;\n  padding: 10px 20px;\n  font-weight: bold;\n  color: #fff;\n  font-size: 16px;\n  text-decoration: none;\n  text-transform: uppercase;\n  overflow: hidden;\n  transition: 0.5s;\n  margin-top: 40px;\n  letter-spacing: 3px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.loginSubmitButton:hover {\n  background: #d65b3c;\n  color: #272727;\n  border-radius: 5px;\n}\n\n.loginSubmitButton span {\n  position: absolute;\n  display: block;\n}\n\n.loginSubmitButton span:nth-child(1) {\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, #d65b3c);\n  animation: btn-anim1 1.5s linear infinite;\n}\n\n@keyframes btn-anim1 {\n  0% {\n    left: -100%;\n  }\n  50%,\n  100% {\n    left: 100%;\n  }\n}\n\n.loginSubmitButton span:nth-child(2) {\n  top: -100%;\n  right: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, transparent, #d65b3c);\n  animation: btn-anim2 1.5s linear infinite;\n  animation-delay: 0.375s;\n}\n\n@keyframes btn-anim2 {\n  0% {\n    top: -100%;\n  }\n  50%,\n  100% {\n    top: 100%;\n  }\n}\n\n.loginSubmitButton span:nth-child(3) {\n  bottom: 0;\n  right: -100%;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(270deg, transparent, #d65b3c);\n  animation: btn-anim3 1.5s linear infinite;\n  animation-delay: 0.75s;\n}\n\n@keyframes btn-anim3 {\n  0% {\n    right: -100%;\n  }\n  50%,\n  100% {\n    right: 100%;\n  }\n}\n\n.loginSubmitButton span:nth-child(4) {\n  bottom: -100%;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(360deg, transparent, #d65b3c);\n  animation: btn-anim4 1.5s linear infinite;\n  animation-delay: 1.125s;\n}\n\n@keyframes btn-anim4 {\n  0% {\n    bottom: -100%;\n  }\n  50%,\n  100% {\n    bottom: 100%;\n  }\n}\n\n.loginEyeIcon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #fff;\n  cursor: pointer;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .loginLoginBox {\n    width: 350px;\n    padding: 30px;\n  }\n\n  .loginLoginHead {\n    font-size: 1.3rem;\n    margin-bottom: 25px;\n  }\n\n  .loginUserBox input {\n    font-size: 14px;\n    padding: 8px 0;\n    margin-bottom: 25px;\n  }\n\n  .loginUserBox label {\n    font-size: 14px;\n    padding: 8px 0;\n  }\n\n  .loginUserBox input:focus ~ label,\n  .loginUserBox input:valid ~ label {\n    top: -18px;\n    font-size: 10px;\n  }\n\n  .loginSubmitButton {\n    padding: 8px 16px;\n    font-size: 14px;\n    margin-top: 30px;\n    letter-spacing: 2px;\n  }\n}\n\n@media (max-width: 480px) {\n  .loginLoginBox {\n    width: 90%;\n    padding: 20px;\n    margin: 10px auto;\n  }\n\n  .loginLoginHead {\n    font-size: 1.2rem;\n    margin-bottom: 20px;\n  }\n\n  .loginUserBox input {\n    font-size: 13px;\n    padding: 6px 0;\n    margin-bottom: 20px;\n  }\n\n  .loginUserBox label {\n    font-size: 13px;\n    padding: 6px 0;\n  }\n\n  .loginUserBox input:focus ~ label,\n  .loginUserBox input:valid ~ label {\n    top: -16px;\n    font-size: 9px;\n  }\n\n  .loginSubmitButton {\n    padding: 6px 12px;\n    font-size: 13px;\n    margin-top: 20px;\n    letter-spacing: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
